export { default as Switch } from './src/Switch'
